import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, IconButton } from '@mui/material';
import moment from 'moment';
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import ImageCustom from 'commons/ImageCustom';

import useStyles from './styles';

const HistoricalImageLightBox = ({ open, onClose, images, initialIndex }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [currentIndex, setCurrentIndex] = useState(initialIndex || 0);
  const thumbnailRefs = useRef([]);

  // Update currentIndex khi initialIndex thay đổi
  useEffect(() => {
    if (open) {
      setCurrentIndex(initialIndex || 0);
    }
  }, [initialIndex, open]);

  // Auto-scroll sidebar đến thumbnail active khi currentIndex thay đổi
  useEffect(() => {
    if (thumbnailRefs.current[currentIndex]) {
      thumbnailRefs.current[currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  }, [currentIndex]);

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : images.length - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex < images.length - 1 ? prevIndex + 1 : 0));
  };

  const handleThumbnailClick = (index) => {
    setCurrentIndex(index);
  };

  const formatDateTime = (dateTime) => {
    return moment(dateTime).format('HH:mm DD/MM/YYYY');
  };

  if (!images || images.length === 0) {
    return null;
  }

  const currentImage = images[currentIndex];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      maxWidth={false}
      PaperProps={{
        className: classes.dialogPaper,
      }}
    >
      <Box className={classes.container}>
        {/* Close Button */}
        <IconButton
          className={classes.closeButton}
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>

        {/* Left Sidebar - Thumbnails */}
        <Box className={classes.sidebar}>
          {images.map((image, index) => (
            <Box
              key={image.id}
              ref={(el) => (thumbnailRefs.current[index] = el)}
              className={`${classes.thumbnailItem} ${
                index === currentIndex ? classes.thumbnailItemActive : ''
              }`}
              onClick={() => handleThumbnailClick(index)}
            >
              <ImageCustom
                src={image.image}
                imageStyle={classes.thumbnailImage}
              />
              <Box className={classes.thumbnailMetadata}>
                <div className={classes.metadataText}>
                  {t('uploaded_at')} {formatDateTime(image.created_at)}
                </div>
                <div className={classes.metadataText}>
                  {t('by')} {image.owner?.name || image.owner_name || ''}
                </div>
              </Box>
            </Box>
          ))}
        </Box>

        {/* Center Area - Main Image */}
        <Box className={classes.centerArea}>
          <img
            src={currentImage.image}
            alt={`Historical image ${currentIndex + 1}`}
            className={classes.mainImage}
          />

          {/* Navigation Buttons */}
          <IconButton
            className={`${classes.navigationButton} ${classes.prevButton}`}
            onClick={handlePrevious}
            aria-label="previous"
          >
            <ArrowBackIosNewIcon />
          </IconButton>

          <IconButton
            className={`${classes.navigationButton} ${classes.nextButton}`}
            onClick={handleNext}
            aria-label="next"
          >
            <ArrowForwardIosIcon />
          </IconButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default HistoricalImageLightBox;
